module.exports = __webpack_public_path__ + "img/hero-ecart-pay.85b2cf11.webp";